import styled from 'styled-components';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { AccordionItem } from '@/components/shared/AccordionItem';
import { FAQ_ITEMS } from '@/utils/constants';
import { theme } from '@/styles/theme';

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};
  color: ${theme.colors.text.black};
`;

const FAQList = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;

interface FAQSectionProps {
  id?: string;
}

export const FAQSection = ({ id }: FAQSectionProps) => {
  return (
    <Section $padding="large" $background={theme.colors.secondary.warm} id={id}>
      <Container>
        <SectionTitle>Questions? We've got answers.</SectionTitle>
        <FAQList>
          {FAQ_ITEMS.map((item, index) => (
            <AccordionItem
              key={index}
              question={item.question}
              answer={item.answer}
              defaultOpen={index === 0}
            />
          ))}
        </FAQList>
      </Container>
    </Section>
  );
};
